import React, { useContext } from "react";
import styled, { ThemeContext } from "styled-components";
import Col from "../../UIcomponent/Column";
import StyledLink from "../../UIcomponent/Link";
import LocalContext from "../../Context/LocalContetxt";
export const StyledHeaderItem = styled(StyledLink)`
  height: 35px;
  border-radius: 5px;
  font-family: "Fa_IRANSansBold";
  font-weight: 800;
  :hover {
    background-color: rgb(250, 246, 244);
    transition: all ease 350ms;
  }
`;
const HeaderLink = (props) => {
  const theme = useContext(ThemeContext);
  const lang = useContext(LocalContext).lang;
  const { items, role, needLogin } = props;

  return items.map((item, index) => {
    return (
      <Col
        width="auto"
        key={`${item.url}-${index}`}
        style={{
          display:
            item.need_login === true && !item.roles.includes(role) && "none",
        }}
      >
        <StyledHeaderItem
          color={"#777777"}
          hoverColor={theme.text}
          to={item.url}
          fontSize={theme.fontSizeMd}
          fontWeight={800}
          width="100%"
          theme={theme}
          newTab={item.newTab === true}
          force={item.force === true}
        >
          {item.name[`${lang}`]}
        </StyledHeaderItem>
      </Col>
    );
  });
};

export default HeaderLink;
